import React, { use, useEffect, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import { useTheme } from '../../../DataStore/ThemeContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import ActivityLoader from '../../Common/ActivityLoader';

const ManageSubject = ({ subjectInfo }) => {
    const [papers, setPapers] = useState(false);
    const [studyUnits, setStudyUnits] = useState(false);
    const {setNewPaper, setDeletePaper, setEditPaper, setNewUnit, setEditUnit, setDeleteUnit} = useConfig();

    useEffect(() => {
        if (subjectInfo && subjectInfo.subject_id) {
            getPapers();
            getStudyUnits();
        }
    }
    , [subjectInfo]);

   

    const getPapers = async() => {
        const server_response = await ajaxConfig.getSubjectPapers(subjectInfo.subject_id);
        if (server_response.status === "OK") {
            setPapers(server_response.details);
        } else {
            setPapers('404');
        }
    };

    const getStudyUnits = async() => {
        const server_response = await ajaxConfig.getSubjectUnits(subjectInfo.subject_id);
        if (server_response.status === "OK") {
            setStudyUnits(server_response.details);
        } else {
            setStudyUnits('404');
        }
    };

    const handleEdit = (item, type) => {
        if(type === 'paper') {
            setEditPaper({ show: true, paper: item, callback: getPapers });
        }else{
            setEditUnit({ show: true, unit: item, callback: getStudyUnits });
        }
    };

    const handleDelete = (item, type) => {
        if(type === 'paper') {
            setDeletePaper({ show: true, paper: item, callback: getPapers });
        }else{
            setDeleteUnit({ show: true, unit: item, callback: getStudyUnits });
        }
    };

    const handleAddNew = (type) => {
        if (type === 'paper') {
            setNewPaper({ show: true, subject: subjectInfo, callback: getPapers });
        }
        else {
            setNewUnit({ show: true, subject: subjectInfo, callback: getStudyUnits });

        }
    };

   const renderList = (items, type) => {

    if(!items){
        return <ActivityLoader />;
    }
       
       return <>
           
            {Array.isArray(items) ? (
                <ul className="list-group mb-4">
                    {items.map((item) => (
                        <li
                            key={item.paper_id || item.unit_id}
                            className="list-group-item d-flex justify-content-between align-items-center"
                        >
                            <span>{item.title || item.paper_code}</span>
                            <div>
                                <button
                                    className="btn btn-sm btn-outline-primary mr-2"
                                    onClick={() => handleEdit(item, type)}
                                >
                                    <i className="fa fa-edit"></i> Edit
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDelete(item, type)}
                                >
                                    <i className="fa fa-trash-alt"></i> Delete
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : (
                <div className="alert alert-light mb-4">
                    No {type === 'paper' ? 'papers' : 'study units'} found.
                </div>
            )}
        </>
   };

    return (
        <div className='card'>
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">{subjectInfo.subject} Papers</h5>
                    <button className="btn btn-sm btn-success" onClick={() => handleAddNew('paper')}>
                        <i className="fa fa-plus"></i> Add Paper
                    </button>
                </div>
                {renderList(papers, 'paper')}

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Study Units</h5>
                    <button className="btn btn-sm btn-success" onClick={() => handleAddNew('unit')}>
                        <i className="fa fa-plus"></i> Add Unit
                    </button>
                </div>
                {renderList(studyUnits, 'unit')}
            </div>
        </div>
    );
};

export default ManageSubject;
